// extracted by mini-css-extract-plugin
export default {"glowOnHover":"UpgradeToPremiumButton_glowOnHover__uAcrT","glowing":"UpgradeToPremiumButton_glowing__wpjtu","glowLoading":"UpgradeToPremiumButton_glowLoading__QEPJI"};